import { Button, mergeClasses, Tooltip } from "@fluentui/react-components";
import { UseCasePromptsModal } from "components/useCasePromptsModal/UseCasePromptsModal";
import { LightbulbIcon } from "icons/LightbulbIcon";
import { useState } from "react";
import { useSharedButtonStyles } from "theme/sharedStyles";
import { useStyles } from "./AddPrompt.styles";
import { IAddPromptProps } from "./AddPrompt.types";

export const AddPrompt = (props: IAddPromptProps): JSX.Element => {
  const sharedButtonStyles = useSharedButtonStyles();
  const styles = useStyles();
  const [openUseCasePromptsModal, setOpenUseCasePromptsModal] =
    useState<boolean>(false);

  const handlePromptButtonClick = (): void => {
    setOpenUseCasePromptsModal(true);
  };

  const handleCloseModal = (): void => {
    setOpenUseCasePromptsModal(false);
  };

  return (
    <>
      <Tooltip content={"Prompts"} relationship={"label"}>
        <Button
          className={mergeClasses(
            sharedButtonStyles.ghostButton,
            styles.roundedPromptsButton,
          )}
          onClick={handlePromptButtonClick}
          icon={<LightbulbIcon size={16} />}
        />
      </Tooltip>

      <UseCasePromptsModal
        open={openUseCasePromptsModal}
        onClose={handleCloseModal}
        onKnowledgeComponentsSelected={props.onKnowledgeComponentsSelected}
        workspaceId={props.workspaceId}
      />
    </>
  );
};
